"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.stat.scheduled': 'Pianificati',
    'socialMediaPlan.stat.drafts': 'Bozze',
    'socialMediaPlan.stat.published': 'Pubblicati',
    'socialMediaPlan.stat.total': 'Totale',
};
